// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b421035f","532":"1ef4cfbd","732":"99fde474","746":"958c09c0","977":"084e604a"}[chunkId] + ".chunk.js";
};